import { useCallback, useMemo, useState } from "react";
import type { RowSelectionState } from "@tanstack/react-table";

export function useCardSelection() {
  const [rowSelection, setRowSelection] = useState<RowSelectionState>({});

  const selectedIds = useMemo(
    () =>
      Object.entries(rowSelection)
        .filter(([, selected]) => selected)
        .map(([id]) => id),
    [rowSelection]
  );

  const toggle = useCallback((id: string) => {
    setRowSelection((prev) => {
      if (prev[id]) {
        const next = { ...prev };
        delete next[id];
        return next;
      }
      return { ...prev, [id]: true };
    });
  }, []);

  const clear = useCallback(() => setRowSelection({}), []);

  return { rowSelection, setRowSelection, selectedIds, toggle, clear };
}
